import type { PropsWithChildren } from "react";

import { styled } from "styled-components";

import { Image as ImageIcon } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import type { ContentType } from "../types";

const MIN_HEIGHT = "164px";

const ImageContainer = ({ children }: PropsWithChildren) => (
    <Stack
        justifyContent="flex-end"
        alignItems="center"
        minHeight={MIN_HEIGHT}
        position="relative"
    >
        {children}
    </Stack>
);

const CreativeImage = styled.img`
    object-fit: contain;
    width: 100%;
    height: 100%;
`;

export interface CreativeSectionProps {
    mediaType: ContentType;
    creativeUrl?: string;
}

export const CreativeSection = ({ mediaType, creativeUrl }: CreativeSectionProps) => {
    if (!creativeUrl) {
        return (
            <Flex
                justifyContent="center"
                alignItems="center"
                minHeight={MIN_HEIGHT}
                background={`linear-gradient(180deg, ${colorsPalettes.carbon[25]} 0%, ${colorsPalettes.carbon[100]} 100%)`}
            >
                <ImageIcon
                    size="xl"
                    color={colorsPalettes.carbon[200]}
                />
            </Flex>
        );
    }

    return (
        <ImageContainer>
            <CreativeImage
                loading="lazy"
                src={creativeUrl}
                alt={`${mediaType} creative`}
            />
        </ImageContainer>
    );
};
